import { ClientEvents } from 'common/events/ClientEvents';
import { Slugs } from 'common/urls/Slugs';
import React from 'react';
import { useIsDishFirst } from 'src/dish-first/useIsDishFirst';
import { useDishFistCartPositionContext } from 'src/pages/consumer/components/ConsumerHeaderWrapper';
import { useConsumerCarts } from 'src/pages/consumer/consumer-carts/useConsumerCarts';
import { TrackedNavLink } from 'src/shared/design-system/TrackedNavLink';
import { useHistory } from 'src/shared/hooks/useHistory';
import { useTracker } from 'src/shared/hooks/useTracker';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath, locationInRoutes } from 'src/shared/utils/RouteUtilities';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import styled from 'styled-components';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { ScreenWidth, ScreenWidthValues } from 'web-common/src/shared/styles';
import { useLocation } from '../../../../../shared/hooks/useLocation';
import { CartButton } from './CartButton';

const name = 'cart';

// TODO (ericso): Noticed this nested button. We should remove this and use a div.
const SlideOutButton = styled.button`
  border: none;
  background: none;
  outline: none;
  padding: 0;

  &:active {
    outline: none;
  }
`;

export const CartNavItem: React.FC = () => {
  const location = useLocation();
  const isEditingOrder = locationInRoutes(location, [Routes.CONSUMER_ORDER_GROUP_ORDER_EDIT]);

  const { carts, numItemsInCart } = useConsumerCarts(isEditingOrder);
  const numCarts = carts.length;

  // Multi shef has a different cart experience than not
  const { isDishFirst } = useIsDishFirst();
  const cartPositionState = useDishFistCartPositionContext();
  const tracker = useTracker();
  const { windowDimensions } = useScreenContext();
  const isMediumOrLargerScreen = windowDimensions.width > ScreenWidthValues[ScreenWidth.SMALL];
  const history = useHistory();
  const [cachedZipCode] = useCachedZipCode();

  const inner = <CartButton displayNum={isDishFirst ? numItemsInCart : numCarts} />;

  if (isDishFirst && isMediumOrLargerScreen) {
    const handleClick = () => {
      tracker.track(ClientEvents.NAV_CLICK, { elementName: name });

      if (cartPositionState.isCartMounted) {
        cartPositionState.toggle();
      } else {
        history.push(getSluggedPath(Routes.CONSUMER_EXPLORE, [{ slug: Slugs.ZIP_CODE, value: cachedZipCode ?? '' }]), {
          autoCloseCart: false,
        });
        cartPositionState.open();
      }
    };

    return <SlideOutButton onClick={handleClick}>{inner}</SlideOutButton>;
  }

  const route = isDishFirst ? Routes.CONSUMER_ORDER_CART : Routes.CONSUMER_MULTIPLE_CARTS_VIEW;

  return isMediumOrLargerScreen ? (
    <TrackedNavLink to={route} name={name}>
      {inner}
    </TrackedNavLink>
  ) : null;
};
